// @flow
import React, {PureComponent} from 'react';
import {Unveil} from '@homeaway/react-unveil';
import xsWhenTravelingImage from './when-traveling-xs@2x.png';
import whenTravelingImage from './when-traveling@2x.png';

type Props = {useXsImage?: boolean};
type State = {imageSrc: string};

// Smallest height on XL_MIN screens
const UNVEIL_MIN_HEIGHT = '88px';

export default class DatesPromptBannerImage extends PureComponent<
    Props,
    State
> {
    state: State = {
        // use a tiny version of image on ssr.
        imageSrc: ''
    };

    componentDidMount() {
        // this relies on the fact that componentDidMount does not execute until client render
        // then, larger resolution image src will be used
        this.onModifyImageSrc();
    }
    componentDidUpdate(prevProps: Props) {
        if (prevProps.useXsImage !== this.props.useXsImage) {
            this.onModifyImageSrc();
        }
    }

    onModifyImageSrc = () => {
        this.setState({
            imageSrc: this.props.useXsImage
                ? // $FlowFixMe
                  xsWhenTravelingImage()
                : // $FlowFixMe
                  whenTravelingImage()
        });
    };

    render() {
        return (
            <Unveil threshold={600} minContainerHeight={UNVEIL_MIN_HEIGHT}>
                <img alt="" src={this.state.imageSrc} />
            </Unveil>
        );
    }
}
